import React from 'react';

import { Divider } from '@material-ui/core';

import makePath from '../../utils/makePath';
import { basicRTEControls } from '../../config/allInteractives';

import { ImageUpload, TextInput, /* TextItemList,*/ RichTextEditor } from '../EditorFormElements';
import { Section } from '.'
import { Collapsible, FormFieldWrapper, SortableList } from '../Global';

// Details is the modal-like subpage that appears when the user clicks "Learn More" on the Topic page of a Progression
export const Details = React.memo(({given = {}, path, ...props})=> {
  path = makePath(path,'details')
  return <>

    {/* Header section */}
    <Collapsible title='Details Header Section' headerTag="h5" grayTheme>

      <FormFieldWrapper>

        <ImageUpload 
          name="headerImage"
          path={path}
          label="Background Image"
          given={given.headerImage}
          tooltip="Upload an image to display as the background. Image size must be 1225px by 386px and not exceed 150KB."
        />

        <TextInput 
          name="title"
          path={path}
          label="Heading"
          defaultText="Heading"
          given={given.title}
        />

        <TextInput 
          name="subtitle"
          path={path}
          label="Subheading"
          defaultText="Subheading"
          given={given.subtitle}
        />

      </FormFieldWrapper>

      <Divider />

        {/* Keywords - on rectangular colored background; lead into intro text */}
        <RichTextEditor
          name="keywords"
          label="Callouts List"
          defaultValue="<ul><li>Callout 1</li><li>Callout 2</li></ul>"
          controls={['bulletList']}
          inlineToolbarControls={false}
          disallowIndent
          given={given.keywords}
          path={path}
          validationCriteria={{
            mustChange: true,
            optional: true,
          }}
          help="This field is optional."
        />
        
    </Collapsible>

    {/* Main section */}
    <Collapsible title="Details Sections" headerTag="h5" grayTheme>

      <h6 className="form-section-header">Main Section</h6>

      <FormFieldWrapper>
        <RichTextEditor 
          name="intro"
          path={path}
          // label="Intro text"
          defaultValue="Enter topic body text for the main section."
          controls={basicRTEControls}
          given={given.intro}
        />

        {props.detailsLayout === 'image' ?
          <ImageUpload
            label="Featured Image"
            name="image" 
            path={path}
            tooltip="Upload a featured image to display below the main body text. Images must have a width of 920px and a minimum height of 614px. File size should not exceed 150KB."
            includeAlt
            altPlaceholder="Provide image alt text to support screen readers."
            altLabel="Image Alt Text"
            includeCaption
            captionPlaceholder="Provide caption text to display below the image."
            captionLabel="Image Caption"
            creditLabel="Image Credit"
            given={given.image}
          />
        : ''}
      </FormFieldWrapper>

      <h6 className="form-section-header">Subsections</h6>
      
      <SortableList
        label="Subsection"
        name="sections"
        path={path}
        given={given.sections}
      >
        <Section />
      </SortableList>

    </Collapsible>
  </>
})
